import { accountProfileConstants as C } from "../actions/constants";

const initialState = {
    user: null,
    newsletterSettings: null,
    loading: false,
    sendingCode: false,
    confirmingCode: false,
    updatingNewsletter: false,
    message: "",
    error: "",
    attemptsLeft: null,
    secondsLeft: 0,
};

export default function accountProfileReducer(state = initialState, action) {
    switch (action.type) {
        case C.SEND_EMAIL_VERIFICATION_REQUEST:
            return {
                ...state,
                sendingCode: true,
                loading: true,
                message: "",
                error: "",
                secondsLeft: 0,
            };

        case C.SEND_EMAIL_VERIFICATION_SUCCESS:
            return {
                ...state,
                sendingCode: false,
                loading: false,
                message: action.payload?.message || "",
                error: "",
                secondsLeft: action.payload?.secondsLeft || 0,
            };

        case C.SEND_EMAIL_VERIFICATION_FAILURE:
            return {
                ...state,
                sendingCode: false,
                loading: false,
                message: "",
                error: action.payload?.error || "Ошибка отправки кода",
                secondsLeft: action.payload?.secondsLeft || 0,
            };

        case C.CONFIRM_EMAIL_VERIFICATION_REQUEST:
            return {
                ...state,
                confirmingCode: true,
                loading: true,
                message: "",
                error: "",
                attemptsLeft: null,
            };

        case C.CONFIRM_EMAIL_VERIFICATION_SUCCESS:
            return {
                ...state,
                confirmingCode: false,
                loading: false,
                user: action.payload?.user || state.user,
                message: action.payload?.message || "Email подтверждён",
                error: "",
                attemptsLeft: null,
            };

        case C.CONFIRM_EMAIL_VERIFICATION_FAILURE:
            return {
                ...state,
                confirmingCode: false,
                loading: false,
                message: "",
                error: action.payload?.error || "Ошибка подтверждения email",
                attemptsLeft: action.payload?.attemptsLeft ?? null,
            };

        case C.UPDATE_NEWSLETTER_SETTINGS_REQUEST:
            return {
                ...state,
                updatingNewsletter: true,
                loading: true,
                message: "",
                error: "",
            };

        case C.UPDATE_NEWSLETTER_SETTINGS_SUCCESS:
            return {
                ...state,
                updatingNewsletter: false,
                loading: false,
                user: action.payload?.user || state.user,
                newsletterSettings: action.payload?.newsletterSettings || state.newsletterSettings,
                message: action.payload?.message || "Настройки рассылки сохранены",
                error: "",
            };

        case C.UPDATE_NEWSLETTER_SETTINGS_FAILURE:
            return {
                ...state,
                updatingNewsletter: false,
                loading: false,
                message: "",
                error: action.payload?.error || "Ошибка сохранения рассылки",
            };

        case C.REFRESH_ACCOUNT_PROFILE_REQUEST:
            return {
                ...state,
                loading: true,
                error: "",
            };

        case C.REFRESH_ACCOUNT_PROFILE_SUCCESS:
            return {
                ...state,
                loading: false,
                user: action.payload?.user || state.user,
                error: "",
            };

        case C.REFRESH_ACCOUNT_PROFILE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload?.error || "Ошибка загрузки профиля",
            };

        case C.CLEAR_ACCOUNT_PROFILE_STATUS:
            return {
                ...state,
                message: "",
                error: "",
                attemptsLeft: null,
                secondsLeft: 0,
            };

        default:
            return state;
    }
}